<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button :content="$t('business.label.picker')+$t('business.label.config')" mode="text" status="primary"/>
      </template>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="fetch()"/>
        <vxe-button content="button.add" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
        <vxe-button content="button.save" icon="vxe-icon-save" mode="text" status="primary" @click="save"/>
      </template>
      <vxe-table ref="table" :data="data" :edit-config="{}" :loading="loading" keep-source>
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="picker.name" title="business.label.picker" width="200"/>
        <vxe-column :edit-render="applicationRender" field="application" title="business.label.application" width="200"/>
        <vxe-column :edit-render="{name:'VxeNumberInput',autoSelect:true}" field="ordinal" title="business.label.ordinal" width="100"/>
        <vxe-column :edit-render="storageRoomRender" field="storageRoom.name" title="business.label.storageRoom"/>
        <vxe-column :cell-render="{name:'VxeSwitch'}" field="available" title="business.label.available" width="70"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <storage-room-modal ref="storageRoomModal" @change="(values,row)=>onInputChange(row,'storageRoom',values[0])"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import { deleteOne, findAll, saveAll } from '@/api/Api'
import { User } from '@/api/dto/common/User'
import { PickerConfig } from '@/api/dto/config/PickerConfig'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import { onInputChange } from '@/utils/util'

export default {
  name: 'PickerTable',
  components: { StorageRoomModal },
  props: {
    applications: { type: Array, default: [] }
  },
  data() {
    return {
      warehouse: Vue.ls.get(WAREHOUSE),
      loading: false,
      data: [],
      page: 1,
      size: 20,
      contentSize: 0,
      picker: new User(),
      applicationRender: {
        name: 'VxeSelect',
        options: this.applications
      },
      storageRoomRender: {
        name: 'VxeInput',
        events: {
          click: ({ row }) => this.$refs.storageRoomModal.open({ available: true }, row),
          clear: ({ row }) => this.onInputChange(row, 'storageRoom')
        }
      }
    }
  },
  methods: {
    onInputChange,
    fetch(user) {
      this.loading = true
      if (user) {
        this.picker = user
      }
      findAll('pickerConfigFactory', { 'picker.id': this.picker.id }).then(res => {
        if (res.success) {
          this.data = res.result.map(item => {
            return new PickerConfig(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    add() {
      const config = new PickerConfig()
      config.available = true
      config.picker = this.picker
      this.data.push(config)
    },
    async save() {
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      let saveData = this.$refs.table.getUpdateRecords().concat(this.$refs.table.getInsertRecords())
      if (saveData.length > 0) {
        this.loading = true
        saveData = saveData.map(item => {
          item.warehouse = this.warehouse
          return item.toJSONObject()
        })
        saveAll('pickerConfigPersister', saveData).then(res => {
          if (res.success) {
            this.fetch()
            this.$message.success(this.$t('message.saveSuccess'))
          }
        }).finally(() => this.loading = false)
      } else {
        this.$message.warning('无数据可保存')
      }
    },
    remove(row) {
      if (row.id) {
        this.loading = true
        deleteOne('pickerConfigDeleter', { id: row.id }).then(res => {
          if (res.success) {
            this.$message.success(this.$t('message.deleteSuccess'))
            this.fetch()
          }
        }).finally(() => this.loading = false)
      } else {
        this.data.splice(this.data.indexOf(row), 1)
      }
    }
  }
}
</script>